import { drawerBlueprint } from "@made-people/blueprint-drawer/blueprint";

drawerBlueprint.override({
  slots: {
    overlay: "fixed inset-0 z-[60]",
    content:
      "fixed z-[80] bg-background-page px-6 py-6 lg:w-fit flex flex-col overflow-x-hidden after:hidden",
    dragHandle:
      "w-1/2 h-1 flex-shrink-0 cursor-grab active:cursor-grabbing rounded-full bg-neutral-200 mb-5 -translate-y-5 lg:hidden",
    headerCloseIcon: "cursor-pointer",
    closeIcon: "absolute top-6 right-6 cursor-pointer z-10",
    header: "flex justify-between pb-4",
  },
  variants: {
    minHeight: {
      none: {
        content: "",
      },
      "half-viewport": {
        content: "min-h-[50dvh]",
      },
    },
    dimmed: {
      none: {
        overlay: "",
      },
      subtle: {
        overlay: "bg-black/40",
      },
      medium: {
        overlay: "bg-black/50",
      },
      strong: {
        overlay: "bg-black/20",
      },
    },
    blurred: {
      none: {
        overlay: "",
      },
      subtle: {
        overlay: "backdrop-blur-sm",
      },
      medium: {
        overlay: "backdrop-blur-md",
      },
      strong: {
        overlay: "backdrop-blur-lg",
      },
    },
    direction: {
      top: {
        content: "top-0 left-0 right-0 h-[66%] mb-24",
        dragHandle: "mx-auto mb-4 bottom-0 absolute",
      },
      bottom: {
        content: "bottom-0 left-0 right-0 mt-24",
        dragHandle: "mb-0 mt-4 mx-auto",
      },
      center: {
        content:
          "top-[auto] left-[auto] bottom-[auto] mt-0 bg-transparent transform-[none] flex justify-center w-full",
        dragHandle: "hidden",
      },
      left: {
        content: "bottom-0 left-0 top-0 h-full lg:min-w-96",
        dragHandle: "right-0 top-[50%] rotate-90 absolute hidden",
      },
      right: {
        content: "bottom-0 top-0 right-0 h-full lg:min-w-96",
        dragHandle: "left-0 top-[50%] rotate-90 absolute",
      },
    },
  },
  defaultVariants: {
    blurred: "none",
    dimmed: "strong",
    minHeight: "none",
  },
});
